import { Link } from 'react-router-dom'

export default function DashboardFooter() {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          {/* Copyright */}
          <div className="text-sm text-gray-500">
            &copy; {new Date().getFullYear()} BarterSheet by NERD LLC. All rights reserved.
          </div>

          {/* Legal Links */}
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm">
            <Link
              to="/legal/terms-of-use"
              className="text-gray-600 hover:text-primary-600 transition-colors"
            >
              Terms of Use
            </Link>
            <Link
              to="/legal/privacy-policy"
              className="text-gray-600 hover:text-primary-600 transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/legal/barter-agreement"
              className="text-gray-600 hover:text-primary-600 transition-colors"
            >
              Barter Agreement
            </Link>
            <Link
              to="/legal/escrow-policy"
              className="text-gray-600 hover:text-primary-600 transition-colors"
            >
              Escrow Policy
            </Link>
            <Link
              to="/legal/rating-reviews-policy"
              className="text-gray-600 hover:text-primary-600 transition-colors"
            >
              Rating & Reviews
            </Link>
            <Link
              to="/dashboard/support"
              className="text-gray-600 hover:text-primary-600 transition-colors"
            >
              Support
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
